import { getUserAndTokenFromStorage } from '@firsttable/functions';
import { User } from '@firsttable/types';
import Logger from '@/lib/logger';
import { AuthType, UserActions } from './actions';

const logger = new Logger('Auth reducer');
// logger.enable()

const { token, cdnToken, user } = getUserAndTokenFromStorage();

export interface InitialStateType {
  user: User | null;
  token: string;
  cdnToken: string;
  loading: boolean;
  isLoggedIn: boolean;
  redirect: boolean | string;
  errorMessage: string | null;
  isGuestLoggedIn: boolean;
}
export const initialState = {
  user,
  token: token || '',
  cdnToken: cdnToken || '',
  loading: false,
  isLoggedIn: false,
  errorMessage: null,
  redirect: false,
  isGuestLoggedIn: false,
};

// eslint-disable-next-line no-shadow
export const authReducer = (initialState: InitialStateType, action: UserActions) => {
  switch (action.type) {
    case AuthType.REDIRECTING:
      logger.debug(AuthType.REDIRECTING);
      return {
        ...initialState,
        user: action.payload.user,
        token: action.payload.token,
        cdnToken: action.payload.cdnToken,
        redirect: action.payload.redirect ?? true,
        isLoggedIn: true,
        loading: action.payload.redirect !== false,
        errorMessage: '',
      };
    case AuthType.GUEST:
      logger.debug(AuthType.GUEST, action.payload);
      return {
        ...initialState,
        isGuestLoggedIn: true,
      };
    case AuthType.SUCCESS:
      logger.debug(AuthType.SUCCESS, action.payload);
      return {
        ...initialState,
        user: action.payload.user,
        token: action.payload.token,
        cdnToken: action.payload.cdnToken,
        isLoggedIn: true,
        redirect: false,
        loading: false,
        errorMessage: '',
      };
    case AuthType.UPDATED:
      if (!action.payload) return initialState;
      logger.debug(AuthType.UPDATED, action.payload);
      return {
        ...initialState,
        user: action.payload.user,
        token: action.payload.token,
        cdnToken: action.payload.cdnToken,
      };
    case AuthType.LOGOUT:
      return {
        ...initialState,
        user: null,
        token: '',
        cdnToken: '',
        redirect: false,
        isLoggedIn: false,
        loading: false,
        errorMessage: '',
      };

    case AuthType.FAILURE:
      return {
        ...initialState,
        isLoggedIn: false,
        loading: false,
        redirect: false,
        errorMessage: action.error,
      };

    default:
      throw new Error(`Unhandled action type`);
  }
};
